import { UploadChangeParam } from "antd/lib/upload"
import { fileTypeText } from "../../../../../services/Afins"
import { destroyAlert, errorAlert, loadingAlert } from "../../../../../utils/alert"
import { parseCustomCsv } from "./parseCsv"

/** Tipos de coleta suportados (cada um vira um submódulo). */
export type TipoColeta =
    | 'Solo'
    | 'Plantas'
    | 'Folhas'
    | 'Raízes'
    | 'Microbiológica'
    | 'Fertilizantes'
    | 'Corretivos'
    | 'Compostos orgânicos'
    | 'Outro'

/**
 * Código de cada tipo de coleta no backend (param `codTipo` do /pedido-laboratorio).
 * Fonte única de verdade — preencher o cod conforme cada submódulo for liberado na API.
 */
export const TIPO_COLETA_COD: Record<TipoColeta, number | null> = {
    'Solo': 282,
    'Plantas': null,
    'Folhas': null,
    'Raízes': null,
    'Microbiológica': null,
    'Fertilizantes': null,
    'Corretivos': null,
    'Compostos orgânicos': null,
    'Outro': null,
}

/** Retorna o codTipo do backend para o tipo de coleta (null se ainda não mapeado). */
export const getCodTipoColeta = (tipo: TipoColeta): number | null => TIPO_COLETA_COD[tipo]

/** Extensões aceitas no upload de resultado (arquivos de texto). */
const EXTENSOES_ACEITAS = ['.csv', '.txt']

//UPLOAD DOS ARQUIVOS
export const handleUploadResult = async (
    info: UploadChangeParam,
    cod: number,
    setResultAnalise,
    setTextCSV,
    setAbrirPreviewFile
) => {
    if (info.file.status === 'done') {
        const nome = (info.file.name ?? '').toLowerCase()
        const extensaoValida = EXTENSOES_ACEITAS.some((ext) => nome.endsWith(ext))
        if (!extensaoValida) {
            errorAlert('Formato inválido. Envie um arquivo .csv ou .txt.', 5000)
            return
        }

        loadingAlert({ msg: 'Carregando...', id: 'upload' })
        const csv = info.file.originFileObj

        const texCsv = await fileTypeText(csv)
        const formatadoTxt = parseCustomCsv(texCsv)

        const base64 = await fileBase64(csv)

        setTextCSV(formatadoTxt)

        setResultAnalise({ base64, cod })

        setAbrirPreviewFile(true)
        destroyAlert('upload')
    }
}


const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })
const fileBase64 = async (file: any) => {
    try {
        const resp = await toBase64(file)

        return resp
    } catch (error) {
        return error
    }
}
